import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#002855' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: 'linear-gradient(135deg, #E87722 0%, #d06a18 100%)' }}>
                <i className="ri-car-fill text-white text-xl"></i>
              </div>
              <div>
                <p className="font-black text-white text-base leading-none">DMV-Xpress Services™</p>
                <p className="text-xs mt-0.5" style={{ color: 'rgba(255,255,255,0.5)' }}>Licensed NRS240A — Las Vegas, NV</p>
              </div>
            </div>
            <p className="text-sm leading-relaxed mb-5" style={{ color: 'rgba(255,255,255,0.5)' }}>
              Licensed third-party DMV document preparation in Las Vegas, NV.{' '}
              <strong style={{ color: 'rgba(255,255,255,0.7)' }}>NOT affiliated with the Nevada DMV.</strong>
            </p>
            <div className="space-y-2">
              {[
                { icon: 'ri-map-pin-fill', text: '4525 S Sandhill Rd, Las Vegas, NV 89121' },
                { icon: 'ri-phone-fill', text: '702.802.8696', href: 'tel:7028028696' },
                { icon: 'ri-mail-fill', text: 'info@dmv-xpress.com', href: 'mailto:info@dmv-xpress.com' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2">
                  <i className={`${item.icon} text-sm flex-shrink-0`} style={{ color: '#E87722' }}></i>
                  {item.href
                    ? <a href={item.href} className="text-sm transition-colors" style={{ color: 'rgba(255,255,255,0.55)' }}
                        onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#fff'; }}
                        onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.55)'; }}>{item.text}</a>
                    : <span className="text-sm" style={{ color: 'rgba(255,255,255,0.45)' }}>{item.text}</span>}
                </div>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm uppercase tracking-wider">DMV Services</h4>
            <ul className="space-y-2.5">
              {[
                ['Vehicle Registration', '/services/vehicle-registration'],
                ['Title Transfer', '/services/title-transfer'],
                ['License Plates', '/services/license-plates'],
                ['Duplicate Title', '/services/duplicate-title'],
                ['Temporary Permits', '/services/temporary-permits'],
                ['Notary Services', '/services/notary'],
              ].map(([label, to], i) => (
                <li key={i}>
                  <Link to={to} className="text-sm transition-colors flex items-center gap-1.5 group" style={{ color: 'rgba(255,255,255,0.5)' }}
                    onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#fff'; }}
                    onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.5)'; }}>
                    <i className="ri-arrow-right-s-line text-xs opacity-0 group-hover:opacity-100 transition-opacity" style={{ color: '#E87722' }}></i>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm uppercase tracking-wider">Info &amp; Resources</h4>
            <ul className="space-y-2.5">
              {[
                ['About Us', '/about'],
                ['DMV Forms', '/forms'],
                ['Fees & Pricing', '/fees'],
                ['FAQ', '/faq'],
                ['Resources & Guides', '/resources'],
                ['Contact & Careers', '/contact'],
              ].map(([label, to], i) => (
                <li key={i}>
                  <Link to={to} className="text-sm transition-colors flex items-center gap-1.5 group" style={{ color: 'rgba(255,255,255,0.5)' }}
                    onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#fff'; }}
                    onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.5)'; }}>
                    <i className="ri-arrow-right-s-line text-xs opacity-0 group-hover:opacity-100 transition-opacity" style={{ color: '#E87722' }}></i>
                    {label}
                  </Link>
                </li>
              ))}
              <li>
                <a href="https://dmv.nv.gov" target="_blank" rel="noopener noreferrer nofollow"
                  className="text-sm transition-colors flex items-center gap-1.5" style={{ color: 'rgba(255,255,255,0.5)' }}
                  onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#fff'; }}
                  onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.5)'; }}>
                  Nevada DMV (Official) ↗
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm uppercase tracking-wider">Office Hours</h4>
            <div className="space-y-2 text-sm mb-6">
              {[['Mon – Fri', '9:00 AM – 5:00 PM'], ['Saturday', '10:00 AM – 3:00 PM'], ['Sunday', 'Closed']].map(([d, h], i) => (
                <div key={i} className="flex justify-between gap-4">
                  <span style={{ color: 'rgba(255,255,255,0.5)' }}>{d}:</span>
                  <span className="font-semibold" style={{ color: h === 'Closed' ? '#E87722' : '#fff' }}>{h}</span>
                </div>
              ))}
            </div>
            <div className="rounded-xl p-4" style={{ backgroundColor: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}>
              <p className="font-bold text-sm mb-1" style={{ color: '#E87722' }}>Appointments Only</p>
              <a href="tel:7028028696" className="text-xl font-black text-white hover:opacity-80 transition-opacity">702.802.8696</a>
            </div>
          </div>
        </div>

        {/* Disclaimer + Bottom */}
        <div className="border-t pt-8" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          <div className="rounded-xl p-4 mb-6" style={{ backgroundColor: 'rgba(232,119,34,0.1)', border: '1px solid rgba(232,119,34,0.2)' }}>
            <p className="text-xs leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)' }}>
              <strong className="text-white">Legal Disclaimer:</strong> DMV-Xpress Services™ is a licensed third-party Document Preparation service in Nevada (NRS240A). We are{' '}
              <strong className="text-white">NOT the Nevada Department of Motor Vehicles</strong> and are not affiliated with any government agency. We are not attorneys and are not authorized to give legal advice. All DMV state fees are separate from our service fees. Appointments required.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="flex flex-wrap gap-5 text-xs">
              {[['Sitemap', '/'], ['Privacy Policy', '/'], ['Contact Us', '/contact'], ['FAQ', '/faq']].map(([label, to], i) => (
                <Link key={i} to={to} className="transition-colors" style={{ color: 'rgba(255,255,255,0.35)' }}
                  onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#fff'; }}
                  onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.35)'; }}>{label}</Link>
              ))}
            </div>
            <p className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>
              © {new Date().getFullYear()} DMV-Xpress Services™. All rights reserved. Licensed Nevada Document Preparation Service.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
